<template>
  <div class="button-container">
    <button @click="selectComponent('Comp_CompetitionAdd')" class="btn btn-success">Opprett Frisys stevne</button>
    <button @click="selectComponent('Comp_CompetitionAddOT')" class="btn btn-success">Importer Opentrack stevne til Frisys Opprop</button>
  </div>
</template>

<script>
export default {
  name: 'AddChoice',
  methods: {
    selectComponent(component) {
      // Emit an event to the parent with the selected component name
      console.log("selectComponent", component);
      this.$emit("select-component", component);
    },
  }
}
</script>

<style scoped>
.button-container {
  display: flex;
  flex-direction: column;
  gap: 10px; /* Space between buttons */
}

.btn {
  padding: 10px 20px;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
